/* eslint-disable jira/filename-case */
export const Experiments = {
	projectTheming: 'projectTheming',
	isSampleProject: 'isSampleProject',
	isNotSampleProject: 'isNotSampleProject',
	trelloCrossflow: 'trelloCrossflow',
} as const;
